import { css } from '@emotion/react';
import { center, borderRadius } from '@atlaskit/media-ui';
import { N20, N50 } from '@atlaskit/theme/colors';
export const wrapperStyles = ({
  dimensions
}) => css(center, {
  background: `var(--ds-background-neutral, ${N20})`,
  color: `var(--ds-icon, ${N50})`
}, borderRadius, {
  maxHeight: '100%',
  maxWidth: '100%',
  width: dimensions.width,
  height: dimensions.height
});